import React, { useState, useRef } from "react";
import styles from "./index.modules.less";
import SoftInfo from "../../image/info.svg";
import Ellipsis from "../../image/ellipsis.svg";
import { useDispatch, useSelector } from "react-redux";
import CardItem from "./cardItem"

const CardList = ({ data }) => {
  const { list = [], total } = data;
  const dispatch = useDispatch();
  const timerRef = useRef(null);

  const showCard = (item, e) => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      dispatch.soft.setCurrentSoft({
        ...item,
        x: e.pageX,
        y: e.pageY,
      });
      dispatch.soft.setCardShow(true);
    }, 300);
  };

  const hideCard = () => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      dispatch.soft.setCurrentSoft(null);
      dispatch.soft.setCardShow(false);
    });
  };

  return (
    <div className={styles.CardList}>
      {list.map((item, index) => {
        return (
          <CardItem data={item} index={index} showCard={showCard} hideCard={hideCard} ></CardItem>
        );
      })}
    </div>
  );
};

export default CardList;
